<template>
  <div class="padding-box">
    <div class="list">
      <div v-for="(item, key) in list" class="item" :key="key">
        <div class="top">
          <img class="avatar" src="./../assets/image/no-head.png" alt="" />
          <div class="name">{{ item.proofSupVOS[0].supName }}</div>
          <div class="btn" @click="handleOpen(key)" v-if="item.proofSupVOS.length > 1">
            <span class="text">{{ !item.active ? '展开' : '收起' }}</span>
            <span
              class="iconfont"
              :class="[item.active ? 'icon-shouqi' : 'icon-zhankai']"
            ></span>
          </div>
        </div>
        <div class="content">
          <div
            class="box"
            v-for="(box, boxKey) in item.proofSupVOS.slice(
              0,
              !item.active ? 1 : item.proofSupVOS.length
            )"
            :key="boxKey"
          >
            <div class="line">
              <span class="label">当前进度</span>
              <span class="value green">{{ box.status }}</span>
            </div>
            <div class="line">
              <span class="label">样品编号</span>
              <span class="value">{{ box.sampleNo }}</span>
            </div>
            <div class="line">
              <span class="label">起始时间</span>
              <span class="value">{{ box.startTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fontBut">
      <div class="but" @click="handleBack()">返回上一级</div>
    </div>
  </div>
</template>

<script>
import { sampleApi } from "../api/lookApi/api";

const pageApi = new sampleApi();

export default {
  name: "SampleSupplier",
  data() {
    return {
      list: [
      ],
    };
  },
  methods: {
    async getList() {
      let res = await pageApi.getOtherInfo(this.$route.query.proofId);
      res.supInfos.forEach((item) => {
        item.active = false;
      })
      this.list = res.supInfos;
    },
    handleOpen(key) {
      this.list[key].active = !this.list[key].active;
    },
    handleBack() {
      this.$router.back();
    }
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.list {
  padding: 30px 30px 200px;
  background-color: #f7f7f7;
  min-height: calc(100vh - 88px);

  .item {
    border-radius: 22px;
    background-color: #fff;
    padding: 18px 30px 30px 30px;
    margin-bottom: 30px;

    .top {
      display: flex;
      align-items: center;

      .avatar {
        width: 60px;
        height: 60px;
        background: #eefff6;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .name {
        margin: 0 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 32px;
        color: #303133;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        text-align: left;
      }

      .btn {
        display: flex;
        gap: 10px;
        color: #999999;

        .text {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 24px;
          color: #999999;
        }

        .iconfont {
          font-size: 20px;
        }
      }
    }

    .content {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 30px;

      .box {
        width: 630px;
        height: 203px;
        background: #f7f7f7;
        border-radius: 12px;
        padding: 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 28px;

          .label {
            color: #606266;
          }

          .value {
            color: #303133;
          }

          .green {
            font-weight: bold;
            color: #3f996c;
          }
        }
      }
    }
  }
}
</style>
